import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { TRADING_NAV_ITEMS, isNavItemActive } from './trading-nav-items';
import MarketStatusBadge from './MarketStatusBadge';
import IstClock from './IstClock';
import ThemeToggle from './ThemeToggle';
import { useScreenMaster } from './ScreenMasterContext';
import './GlobalTradingNav.css';

/**
 * Standard single-row sticky navbar — light & dark via theme tokens.
 * Mobile: brand + meta here; primary links in MobileBottomNav.
 */
export default function GlobalTradingNav() {
  const { pathname } = useLocation();
  const { isNavKeyEnabled } = useScreenMaster();
  const items = TRADING_NAV_ITEMS.filter(
    (item) => item.key === 'screen-master' || isNavKeyEnabled(item.key)
  );

  return (
    <header className="global-trading-nav" role="banner">
      <div className="global-trading-nav-inner">
        <Link to="/ScreenMaster" className="global-trading-nav-brand" aria-label="Bharat Desk home">
          <span className="global-trading-nav-logo" aria-hidden />
          <strong className="global-trading-nav-brand-name">Bharat Desk</strong>
        </Link>

        <nav className="global-trading-nav-links" aria-label="Main">
          {items.map((item) => (
            <Link
              key={item.key}
              to={item.path}
              className={[
                'global-trading-nav-link',
                isNavItemActive(pathname, item) ? 'active' : '',
                item.highlight ? 'is-highlight' : ''
              ].filter(Boolean).join(' ')}
            >
              {item.label}
            </Link>
          ))}
        </nav>

        <div className="global-trading-nav-meta">
          <ThemeToggle compact />
          <IstClock />
          <MarketStatusBadge />
        </div>
      </div>
    </header>
  );
}
